import { DisplayMessage } from '../builders/display_message_builder';
import { IDisplayMessagesDatasource } from '../datasources/display_message_datasource';
import * as _4 from 'lodash4';

export interface IDisplayMessageService {
    (key: string): DisplayMessage;
}

angular
  .module('capability-ng-global')
  .service('ngDisplayMessageService', (ngDisplayMessagesDatasource: IDisplayMessagesDatasource) => {
    return (key: string) => {
      return _4(ngDisplayMessagesDatasource.values()).find({ key: key }) || {};
    };
  });



// WEBPACK FOOTER //
// ./app/lib/global/services/display_message_service.ts